<div class="container-fluid">
  <div class="card mb-3" *ngIf="campaign">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div>
        <button class="btn btn-sm btn-link ps-0" (click)="back()">&larr; Back to campaigns</button>
        <h5 class="mb-0">{{ campaign.name }}</h5>
      </div>
      <button class="btn btn-outline-secondary btn-sm" (click)="refresh()">Refresh</button>
    </div>
    <div class="card-body">
      <div class="row text-center">
        <div class="col"><div class="text-muted small">Template</div><strong>{{ campaign.templateName }}</strong></div>
        <div class="col"><div class="text-muted small">Status</div><strong>{{ campaign.status }}</strong></div>
        <div class="col"><div class="text-muted small">Total</div><strong>{{ campaign.totalRecipients }}</strong></div>
        <div class="col"><div class="text-muted small">Sent</div><strong>{{ campaign.sentCount }}</strong></div>
        <div class="col"><div class="text-muted small">Delivered</div><strong>{{ campaign.deliveredCount }}</strong></div>
        <div class="col"><div class="text-muted small">Read</div><strong>{{ campaign.readCount }}</strong></div>
        <div class="col"><div class="text-muted small">Failed</div><strong>{{ campaign.failedCount }}</strong></div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h6 class="mb-0">Recipients</h6>
      <div class="d-flex align-items-center">
        <label class="me-2 mb-0 small text-muted">Status</label>
        <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="statusFilter" (change)="onFilterChange()">
          <option *ngFor="let s of statuses" [value]="s">{{ s === 'all' ? 'All' : s }}</option>
        </select>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th>#</th>
              <th>Mobile Number</th>
              <th>Status</th>
              <th>Error</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="5" class="text-center text-muted">Loading...</td>
            </tr>
            <tr *ngIf="!loading && recipients.length === 0">
              <td colspan="5" class="text-center text-muted">No recipients.</td>
            </tr>
            <tr *ngFor="let r of recipients; let i = index">
              <td>{{ (page - 1) * pageSize + i + 1 }}</td>
              <td>{{ r.mobileNumber }}</td>
              <td><span [class]="statusClass(r.status)">{{ r.status }}</span></td>
              <td class="text-danger small">{{ r.errorMessage }}</td>
              <td>{{ r.updatedAt | date:'medium' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="d-flex justify-content-end" *ngIf="count > pageSize">
        <ngb-pagination [collectionSize]="count" [(page)]="page" [pageSize]="pageSize"
          (pageChange)="onPageChange($event)" [maxSize]="5" [rotate]="true" [boundaryLinks]="true">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
